import { getAssetTypeMaxCopyLength } from 'src/data/asset';
import { getGenderLabel } from 'src/data/demographics';
import { getGroupByTool, getToolDefaultAssetType, getToolLabel } from 'src/data/generationTool';
import { sendMessageToParent } from 'src/lib/messages';
import { messageSubmitInstructions } from './messages';
import { formatGenerationPrompt } from './prompt';
import { serializePromptComponent } from './components';

/**
 * Send generated from params prompt to extension, asking it to replace current "prompt input" value
 */
export const sendFullPromptToInfinityExtension = (generationParams) => {
  const text = formatGenerationPrompt(generationParams);
  const message = messageSubmitInstructions({
    type: 'prompt',
    params: prepareGenerationParams(generationParams),

    // 2023-07-17: deprecated, remove after Extension 0.0.26 is not in use anymore
    text,
    name: getToolLabel(generationParams?.generationTool),
    generationTool: generationParams?.generationTool,
    generationToolGroup: getGroupByTool(generationParams?.generationTool),
  });
  sendMessageToParent(message);
};

/**
 * Send prompt component to extension, asking it to append to current "prompt input" value
 */
export const sendPromptComponentToInfinityExtension = (promptComponent) => {
  const text = serializePromptComponent(promptComponent);
  const message = messageSubmitInstructions({
    type: 'component',
    text,
  });
  sendMessageToParent(message);
};

function prepareGenerationParams(params) {
  const result = { ...params };

  result.generationToolLabel = getToolLabel(result.generationTool);
  result.generationToolGroup = getGroupByTool(result.generationTool);
  result.assetType = getToolDefaultAssetType(result.generationTool);
  result.maxAssetTypeLength = getAssetTypeMaxCopyLength(result.assetType);

  if (result.customerPersona) {
    result.customerPersona.genderLabel = getGenderLabel(result.customerPersona.gender);
  }

  delete result.shouldWaitForBriefExtraction;

  return result;
}
